(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ma-cro-wear"] && !Shopify.designMode) return;
  try {
    (() => {
    let scheduled = false;
    const sync = () => {
      scheduled = false;
      const config = document.querySelector('media-gallery[data-ma-cg] script[data-ma-cg-cfg]');
      if (!config) return;
      let lane;
      try { lane = JSON.parse(config.textContent).ctx || 'unisex'; } catch { return; }
      document.querySelectorAll('[data-ma-rec-lanes]').forEach(section => {
        let visibleCards = 0;
        section.querySelectorAll('[data-ma-rec-lane]').forEach(list => {
          const show = list.dataset.maRecLane === lane;
          list.hidden = !show;
          if (show) visibleCards += list.children.length;
        });
        section.hidden = visibleCards === 0;
      });
    };
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(sync);
    }).observe(document.body, {childList:true, subtree:true});
    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ma-new-arrivals"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link = event.target.closest('[data-ma-new-audience]');
    if (!link) return;
    try { sessionStorage.setItem('ma_g',link.dataset.maNewAudience); } catch {}
  });
  } catch(e) { console.error(e); }
})();

})();
